import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Screens from '..';
import QueryParamsProxy from '../../utils/queryParamProxy';
import routeParamConstants from '../../utils/routeParamConstants';
import audio from '../../utils/audio';
import CopySelector from '../../utils/copySelector';
import { getText, TEXT_KEY } from '../../utils/localization';

var LinkAccount = /*#__PURE__*/function (_Component) {
  _inherits(LinkAccount, _Component);

  var _super = _createSuper(LinkAccount);

  function LinkAccount() {
    var _this;

    _classCallCheck(this, LinkAccount);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.linkedAccount = function (copys) {
      audio.onClick();
      var asset = _this.props.assetsUrls.ImagesCdnBaseUrl + '/' + _this.props.cardLinkPopupImage;
      var linkAccountDetails = {
        linkAccountTitle: getText(TEXT_KEY.LINK_ACCOUNT_TITLE),
        buttonLabel: getText(TEXT_KEY.LINK_ACCOUNT_BUTTON),
        availableCards: {
          bronze: getText(TEXT_KEY.BRONZE),
          silver: getText(TEXT_KEY.SILVER),
          gold: getText(TEXT_KEY.GOLD),
          platinum: getText(TEXT_KEY.PLATINUM),
          diamond: getText(TEXT_KEY.DIAMOND)
        },
        icon: _this.props.cardLinkPopupImage && asset,
        subtitle: CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_ACCOUNT_SUBTITILE, copys),
        description: CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_ACCOUNT_DESCRIPTION, copys)
      };
      return linkAccountDetails;
    };

    _this.handleLinkAccountForm = function () {
      return QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, Screens.LinkAccountForm));
    };

    return _this;
  }

  _createClass(LinkAccount, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          memberLevel = _this$props.memberLevel,
          isAccountLinked = _this$props.isAccountLinked,
          copys = _this$props.copys;
      return this.props.render({
        memberLevel: memberLevel,
        isAccountLinked: isAccountLinked,
        linkAccount: this.linkedAccount(copys),
        handleLinkAccountForm: this.handleLinkAccountForm,
        linkedLoyaltyCardBonus: this.props.linkedLoyaltyCardBonus
      });
    }
  }]);

  return LinkAccount;
}(Component);

export { LinkAccount as default };